module.exports = __webpack_public_path__ + "static/media/3.698c0857.jpg";